import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Chat.svg",
  "use": "Chat.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Chat.svg\"><path d=\"M32.01,54.0208a25.5568,25.5568,0,0,1-4.69-.498,2.5855,2.5855,0,0,0-2.0544.5322,21.0889,21.0889,0,0,1-10.0576,3.9528A1.0907,1.0907,0,0,1,14.1922,56.31a15.5326,15.5326,0,0,0,2.9595-5.9667,1.613,1.613,0,0,0-.6024-1.5707A21.1588,21.1588,0,0,1,8.01,32.0208c0-12.1352,10.7452-22,24-22s24,9.8648,24,22S45.2651,54.0208,32.01,54.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol